import {
  deleteAdminV1StoresStoreIdMenusId,
  getAdminV1StoresStoreIdMenus,
  getAdminV1StoresStoreIdMenusId,
  patchAdminV1StoresStoreIdMenusId,
  postAdminV1StoresStoreIdMenus,
  putAdminV1StoresStoreIdMenusIdItems,
  type Menu,
  type PatchAdminV1StoresStoreIdMenusIdBody,
  type PostAdminV1StoresStoreIdMenusBody,
  type PutAdminV1StoresStoreIdMenusIdItemsBody,
} from '@nucleus-commerce/api-client/admin';

/** Navigation menus of one store; items are replaced as a whole tree. */
export const menusApi = {
  list: (storeId: string): Promise<Menu[]> =>
    getAdminV1StoresStoreIdMenus({ storeId }).then((r) => r.items),
  get: (storeId: string, id: string): Promise<Menu> =>
    getAdminV1StoresStoreIdMenusId({ storeId, id }),
  create: (storeId: string, body: PostAdminV1StoresStoreIdMenusBody): Promise<Menu> =>
    postAdminV1StoresStoreIdMenus({ storeId }, body),
  update: (
    storeId: string,
    id: string,
    body: PatchAdminV1StoresStoreIdMenusIdBody,
  ): Promise<Menu> => patchAdminV1StoresStoreIdMenusId({ storeId, id }, body),
  replaceItems: (
    storeId: string,
    id: string,
    body: PutAdminV1StoresStoreIdMenusIdItemsBody,
  ): Promise<Menu> => putAdminV1StoresStoreIdMenusIdItems({ storeId, id }, body),
  remove: (storeId: string, id: string): Promise<void> =>
    deleteAdminV1StoresStoreIdMenusId({ storeId, id }),
};
